type ImpactStyle = 'light' | 'medium' | 'heavy' | 'rigid' | 'soft';

interface TelegramHaptics {
  impactOccurred(style: ImpactStyle): void;
  notificationOccurred(type: 'error' | 'success' | 'warning'): void;
  selectionChanged(): void;
}

interface TelegramWebApp {
  initData: string;
  version: string;
  platform: string;
  colorScheme: 'light' | 'dark';
  ready(): void;
  expand(): void;
  requestFullscreen?: () => void;
  disableVerticalSwipes?: () => void;
  setHeaderColor?: (color: string) => void;
  setBackgroundColor?: (color: string) => void;
  HapticFeedback?: TelegramHaptics;
  BackButton?: { show(): void; hide(): void; onClick(callback: () => void): void; offClick(callback: () => void): void };
}

declare global {
  interface Window { Telegram?: { WebApp?: TelegramWebApp } }
}

export function telegram(): TelegramWebApp | null {
  return window.Telegram?.WebApp ?? null;
}

export function initializeTelegram(): void {
  const webApp = telegram();
  if (!webApp) return;
  webApp.ready();
  webApp.expand();
  webApp.disableVerticalSwipes?.();
  webApp.setHeaderColor?.('#05070d');
  webApp.setBackgroundColor?.('#05070d');
}

export function haptic(kind: 'touch' | 'create' | 'merge' | 'pop' | 'success', enabled = true): void {
  if (!enabled) return;
  const api = telegram()?.HapticFeedback;
  if (!api) return;
  try {
    if (kind === 'success') api.notificationOccurred('success');
    else if (kind === 'touch') api.selectionChanged();
    else api.impactOccurred(kind === 'create' ? 'light' : 'medium');
  } catch {
    // Older Telegram clients safely continue without haptics.
  }
}
